import React from "../../_snowpack/pkg/react.js";
import AttributesGroupForm from "./AttributesGroupForm.js";
import {UserProfileProvider} from "./UserProfileContext.js";
const AttributesGroupDetails = () => /* @__PURE__ */ React.createElement(UserProfileProvider, null, /* @__PURE__ */ React.createElement(AttributesGroupForm, null));
export default AttributesGroupDetails;
